import React, {useEffect,useRef} from 'react';
import {createPortal} from 'react-dom';
export default function Dialog({title,children,onClose,wide=false}) {
  const ref=useRef(null), closeRef=useRef(onClose);
  closeRef.current=onClose;
  useEffect(()=>{
    const previous=document.activeElement;
    ref.current?.querySelector('button,input,select,textarea')?.focus();
    const key=e=>{
      if(e.key==='Escape'){
        // Первый Escape закрывает список Joy, следующий — сам диалог.
        if(e.defaultPrevented||document.querySelector('[data-storage-popup="true"]'))return;
        e.stopPropagation();closeRef.current();
      }
      if(e.key==='Tab'){
        if(e.defaultPrevented)return;
        const all=[...ref.current.querySelectorAll('button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),a[href]')]
          .filter(el=>el.tabIndex>=0&&el.getClientRects().length>0);
        const first=all[0],last=all[all.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
      }
    };
    const root=ref.current;root.addEventListener('keydown',key);
    return()=>{root.removeEventListener('keydown',key);previous?.focus?.();};
  },[]);
  return createPortal(<div className="st-overlay" onMouseDown={e=>{if(e.target===e.currentTarget)onClose();}}><section className={`st-dialog ${wide?'st-wide':''}`} ref={ref} role="dialog" aria-modal="true" aria-label={title}>
    <header><h2>{title}</h2><button aria-label="Закрыть" onClick={onClose}>×</button></header>{children}</section></div>,document.body);
}